import {Component, OnInit} from '@angular/core';
import {IQrcreate} from '@entities/qr-code/qr-code.model';
import {ITEMS_PER_PAGE, PAGE_SIZE_OPTIONS} from '@app/shared';
import {MatTableDataSource} from '@angular/material/table';
import {PageEvent} from '@angular/material/paginator';
import {exportFileData} from '@shared/util/export-file';
import {QrCodeService} from '@entities/qr-code/qr-code.service';
import {ActivatedRoute, Data} from '@angular/router';
import {DialogService} from '@shared/confirm-dialog/dialog.service';

@Component({
  selector: 'app-qr-code-detail-activity',
  templateUrl: './qr-code-detail-activity.component.html',
  styleUrls: ['./qr-code-detail-activity.component.scss'],
})
export class QrCodeDetailActivityComponent implements OnInit {
  displayedColumns: string[] = [
    'activityTypeDescription',
    'createdByName',
    'ageDay',
    'executeDate',
    'position',
    'description',
  ];
  ELEMENT_DATA: IQrcreate[];
  dataSource: any;
  totalItems: any;
  itemsPerPage: any;
  pageSizeOptions: number[];
  queryParams: any = null;
  page = 1;
  noData: boolean;
  isLoading = true;

  constructor(
    private qrCodeService: QrCodeService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.ELEMENT_DATA = [];
    this.dataSource = new MatTableDataSource([]);
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
  }

  ngOnInit() {
    this.loadAll();
  }

  loadAll() {
    this.activatedRoute.data.subscribe(({data}: Data) => {
      this.fillData(data);
    });
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadAll();
  }

  fillData(data: any): void {
    this.isLoading = false;
    this.totalItems = data.content.length;
    const startIndex = this.itemsPerPage * (this.page - 1);
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.totalItems);
    this.ELEMENT_DATA = data.content.slice(startIndex, endIndex);
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.noData = data.content.length === 0;
  }
}
